export const HIGH_SCHOOL_TYPES = ['Small HS', 'Large HS', '6 to 12', 'Transfer'];

export const EMS_SCHOOL_TYPES = ['K to 5', 'K to 8', '6 to 8', '6 to 12'];
